// import React, { useState } from "react";
// import "./contact.css";
// import Layout from "./../Layout/Layout";
// // import contact from "../../assets/contactpage3.png";
// import contact from "../../assets/newImg/contactpage8.jpg";

// import { useNavigate, Link } from "react-router-dom";
// const Contact = () => {
//   const navigate = useNavigate();
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [phone, setPhone] = useState("");
//   const [pincode, setPincode] = useState("");
//   const [profession, setProfession] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     navigate("/services");
//   };

//   // const handleChange = (e) => {
//   //   setFormData({ ...formData, [e.target.name]: e.target.value });
//   // };

//   // const handleSubmit = (e) => {
//   //   e.preventDefault();
//   //   console.log("Form submitted:", formData);
//   //   // Add form submission logic (API, email, etc.)
//   // };
//   return (
//     <Layout>
//       <>
//         <div className="contaier-fluid  mb-xxl-4 mb-xl-3 mb-lg-3 mb-md-3  mb-2 ">
//           <div className="container">
//             <div className="row">
//               <div
//                 className="contactImg contactImg1"
//                 style={{
//                   backgroundImage: `url(${contact})`,
//                   backgroundRepeat: "no-repeat",
//                   backgroundSize: "100% 100%",
//                   backgroundPosition: "center",
//                   borderRadius: "30px",
//                 }}
//               >
//                 {/* <h3 className="contacth1">Contact Us</h3> */}
//               </div>
//             </div>
//           </div>

//           <div className="container-fluid join-chat-section  join-section-overlay mt-xl-5 mt-lg-5  mt-3">
//             <div className="container ">
//               <div className="row ">
//                 <div className="col-12  ">
//                   <h3 className="text-center abth1 my-xxl-5 my-xl-5 my-lg-5 my-md-3  my-sm-2 my-2">
//                     Contact Us{" "}
//                   </h3>
//                   <p className="abtP my-xxl-5 my-xl-5 my-lg-5 my-md-3  my-sm-2 my-2">
//                     For inquiries or to join Mestry Circle, reach us at
//                     <span className="linkP">
//                       {" "}
//                       contact@mestrycircle.com.
//                     </span>{" "}
//                     Visit our website at{" "}
//                     <span className="linkP">www.mestrycircle.com</span> /
//                     contact-us for more information. Follow us on social media
//                     for the latest updates and news. We’re excited to connect,
//                     collaborate, and help you grow your business!.
//                   </p>
//                 </div>
//               </div>
//               <div className="row d-flex justify-content-around">
//                 {" "}
//                 <div className="col-md-12 col-lg-6 my-xxl-4 my-lg-3 my-md-2 my-sm-1 my-2">
//                   {" "}
//                   <iframe
//                     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.1489969194486!2d77.61400677484!3d12.898139187410544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15792a4bc145%3A0x7fcd352d0ecfb49e!2sFicuslot%20Innovation%20Pvt%20Ltd.!5e0!3m2!1sen!2sin!4v1759753329426!5m2!1sen!2sin"
//                     className="contactLoc"
//                     allowFullScreen=""
//                     loading="lazy"
//                     referrerPolicy="no-referrer-when-downgrade"
//                   ></iframe>
//                 </div>
//                 <div className="col-md-8 col-sm-10  col-lg-5 my-xxl-0 my-lg-0 my-md-0 my-sm-2 my-2 ">
//                   <div className="  p-3 my-3 my-lg-4 my-xl-4 my-md-3 my-sm-3">
//                     <div className="card p-2 shadow signUpCard contactForm contactForm2">
//                       {/* Close Icon */}

//                       <h4 className="text-center loginMain my-2 my-xl-3 my-lg-3 my-md-3 my-sm-3">
//                         {" "}
//                         Let’s chat with{" "}
//                         <span className="loginSpan">our team.</span>
//                       </h4>
//                       <form
//                         onSubmit={handleSubmit}
//                         className="px-2 px-sm-3 px-md-3 px-lg-4"
//                       >
//                         <div className="col-12  mb-3">
//                           <label className="form-label formLabel m-0">
//                             Fisrt Name <span className="spanLogin">*</span>
//                           </label>
//                           <input
//                             type="text"
//                             className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
//                             value={name}
//                             onChange={(e) => setName(e.target.value)}
//                             required
//                           />
//                         </div>

//                         <div className="col-12  mb-3">
//                           <label className="form-label formLabel m-0">
//                             Email Address <span className="spanLogin">*</span>
//                           </label>
//                           <input
//                             type="email"
//                             className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                             required
//                           />
//                         </div>

//                         <div>
//                           <label className="form-label formLabel m-0">
//                             Phone number <span className="spanLogin">*</span>
//                           </label>
//                           <div className="input-group mb-3 d-flex gap-2  p-0 p-sm-1 p-md-1 p-lg-1">
//                             <input
//                               type="text"
//                               className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
//                               value={phone}
//                               onChange={(e) => setPhone(e.target.value)}
//                               required
//                             />
//                           </div>
//                         </div>

//                         <div>
//                           <label className="form-label formLabel m-0">
//                             Pincode <span className="spanLogin">*</span>
//                           </label>
//                           <div className="input-group mb-3 d-flex gap-2  p-0 p-sm-1 p-md-1 p-lg-1">
//                             <input
//                               type="text"
//                               className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
//                               value={pincode}
//                               onChange={(e) => setPincode(e.target.value)}
//                               required
//                             />
//                           </div>
//                         </div>
//                         <div className="col-12  mb-3">
//                           <label className="form-label formLabel m-0">
//                             Profession <span className="spanLogin">*</span>
//                           </label>
//                           <input
//                             type="text"
//                             className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
//                             value={profession}
//                             onChange={(e) => setProfession(e.target.value)}
//                             required
//                           />
//                         </div>
//                         <div className="form-check mb-3">
//                           <input
//                             className="form-check-input signupCheckbox p-0 p-sm-1 p-md-1 p-lg-1"
//                             type="checkbox"
//                             id="flexCheckChecked"
//                             defaultChecked
//                           />
//                           <label
//                             className="form-check-label"
//                             htmlFor="flexCheckChecked"
//                           >
//                             <span className="signUpSpan">
//                               By continuing, you agree to Mestry circle
//                             </span>
//                             <Link to="/" className="singupLink">
//                               Terms of Use
//                             </Link>{" "}
//                             and{" "}
//                             <Link to="/" className="singupLink">
//                               Privacy Policy
//                             </Link>
//                             .
//                           </label>
//                         </div>

//                         <div className="text-center mb-3">
//                           <button className="loginBtn w-100">Save</button>
//                         </div>
//                       </form>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </>
//     </Layout>
//   );
// };

// export default Contact;

import React, { useState } from "react";
import "./contact.css";
import Layout from "./../Layout/Layout";
// import contact from "../../assets/contactpage3.png";
import contact from "../../assets/newImg/contact11.jpg";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
const Contact = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pincode, setPincode] = useState("");
  const [profession, setProfession] = useState("");

  const validateForm = () => {
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return false;
    }

    // Phone number validation (10 digits India)
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Please enter a valid 10-digit phone number");
      return false;
    }

    // Pincode validation (6 digits India)
    const pincodeRegex = /^\d{6}$/;
    if (!pincodeRegex.test(pincode)) {
      toast.error("Please enter a valid 6-digit pincode");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const data = await axios.post(
        " https://adminmestry.tannis.in/api/contact/",
        {
          first_name: name,
          email,
          phone,
          pincode,
          profession,
        }
      );
      toast.success(
        "Thanks for submitting your enquiry. Our team will contact you soon."
      );

      setName("");
      setEmail("");
      setPhone("");
      setPincode("");
      setProfession("");
      navigate("/services");
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error.message ||
          "Something went wrong"
      );
    }
  };
  return (
    <Layout>
      <>
        <div className="contaier-fluid   ">
          <div className="container">
            <div className="row">
              <div
                className="contactImg contactImg1 mb-xxl-4 mb-xl-4 mb-lg-4 mb-md-3  mb-3"
                style={{
                  backgroundImage: `url(${contact})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "center",
                  borderRadius: "30px",
                }}
              >
                {/* <h3 className="contacth1">Contact Us</h3> */}
              </div>
            </div>
          </div>

          <div className="container-fluid join-chat-section  join-section-overlay mt-xl-5 mt-lg-5  mt-3  mb-xl-4 mt-lg-4  ">
            <div className="container ">
              <div className="row ">
                <div className="col-12  ">
                  <h3 className="text-center contacth1 my-xxl-5 my-xl-5 my-lg-5  my-3">
                    Contact Us{" "}
                  </h3>
                  <p className="abtP my-xxl-5 my-xl-5 my-lg-5 my-md-3  my-sm-2 my-2">
                    For inquiries or to join Mestry Circle, reach us at
                    <span className="linkP">
                      {" "}
                      contact@mestrycircle.com.
                    </span>{" "}
                    Visit our website at{" "}
                    <span className="linkP">www.mestrycircle.com</span> /
                    contact-us for more information. Follow us on social media
                    for the latest updates and news. We’re excited to connect,
                    collaborate, and help you grow your business!.
                  </p>
                </div>
              </div>
              <div className="row d-flex justify-content-around ">
                {" "}
                <div className="col-md-12 col-lg-6 my-md-3  my-sm-3 my-2 mb-xl-5 mb-lg-5  ">
                  {" "}
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.1489969194486!2d77.61400677484!3d12.898139187410544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15792a4bc145%3A0x7fcd352d0ecfb49e!2sFicuslot%20Innovation%20Pvt%20Ltd.!5e0!3m2!1sen!2sin!4v1759753329426!5m2!1sen!2sin"
                    className="contactLoc"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
                <div className="col-md-8 col-sm-10  col-lg-5 mb-xl-5  mb-lg-5  my-md-3 my-sm-3 my-2 ">
                  <div className="  ">
                    <div className="card p-2 shadow signUpCard contactForm contactForm2">
                      {/* Close Icon */}

                      <h4 className="text-center loginMain my-2 my-xl-3 my-lg-3 my-md-3 my-sm-3">
                        {" "}
                        Let’s chat with{" "}
                        <span className="loginSpan">our team.</span>
                      </h4>
                      <form
                        onSubmit={handleSubmit}
                        className="px-2 px-sm-3 px-md-3 px-lg-4"
                      >
                        <div className="col-12  mb-3">
                          <label className="form-label formLabel m-0">
                            Fisrt Name <span className="spanLogin">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                          />
                        </div>

                        <div className="col-12  mb-3">
                          <label className="form-label formLabel m-0">
                            Email Address <span className="spanLogin">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>

                        <div>
                          <label className="form-label formLabel m-0">
                            Phone number <span className="spanLogin">*</span>
                          </label>
                          <div className="input-group mb-3 d-flex gap-2  p-0 p-sm-1 p-md-1 p-lg-1">
                            <input
                              type="text"
                              className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div>
                          <label className="form-label formLabel m-0">
                            Pincode <span className="spanLogin">*</span>
                          </label>
                          <div className="input-group mb-3 d-flex gap-2  p-0 p-sm-1 p-md-1 p-lg-1">
                            <input
                              type="text"
                              className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
                              value={pincode}
                              onChange={(e) => setPincode(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-12  mb-3">
                          <label className="form-label formLabel m-0">
                            Profession <span className="spanLogin">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control p-0 p-sm-1 p-md-1 p-lg-1"
                            value={profession}
                            onChange={(e) => setProfession(e.target.value)}
                            required
                          />
                        </div>
                        <div className="form-check mb-3">
                          <input
                            className="form-check-input signupCheckbox p-0 p-sm-1 p-md-1 p-lg-1"
                            type="checkbox"
                            id="flexCheckChecked"
                            defaultChecked
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckChecked"
                          >
                            <span className="signUpSpan">
                              By continuing, you agree to Mestry circle
                            </span>
                            <Link
                              to="/terms-conditions"
                              className="singupLink2"
                            >
                              Terms of Use
                            </Link>{" "}
                            and{" "}
                            <Link to="/privacy-policy" className="singupLink2">
                              Privacy Policy
                            </Link>
                            .
                          </label>
                        </div>

                        <div className="text-center ">
                          <button className="loginBtn w-100 mt-xl-3 mt-lg-3 mt-md-3 mt-0">
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </Layout>
  );
};

export default Contact;
